module.exports = __webpack_public_path__ + "img/close.c748de6b.svg";